import { render, staticRenderFns } from "./ValentinesDay_defaultSection.vue?vue&type=template&id=313c8e28&scoped=true"
import script from "./ValentinesDay_defaultSection.vue?vue&type=script&lang=ts"
export * from "./ValentinesDay_defaultSection.vue?vue&type=script&lang=ts"
import style0 from "./ValentinesDay_defaultSection.vue?vue&type=style&index=0&id=313c8e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313c8e28",
  null
  
)

export default component.exports